export const CREATE_LEAVE_REQUEST_MUTATION = `
  mutation CreateLeaveRequest($object: leave_requests_insert_input!) {
    insert_leave_requests_one(object: $object) {
      id
      start_date
      end_date
      leave_type
      duration
      company_id
      user_id
      team_id
      group_id
      status
      user {
        id
        first_name
        last_name
        email
      }
      leaveType {
        id
        leave_type_name
        leave_type_description
      }
      company {
        id
        name
      }
    }
  }
`;

export const APPROVE_LEAVE_REQUEST_MUTATION = `
  mutation ApproveLeaveRequest($id: Int!, $updateFields: leave_requests_set_input!) {
    update_leave_requests_by_pk(pk_columns: {id: $id}, _set: $updateFields) {
      id
      status
      is_team_manager_approved
      is_group_manager_approved
      is_final_approved
      approving_manager_id
      approving_manager {
        first_name
        last_name
      }
    }
  }
`;

export const REJECT_LEAVE_REQUEST_MUTATION = `
  mutation RejectLeaveRequest($id: Int!, $updateFields: leave_requests_set_input!) {
    update_leave_requests_by_pk(pk_columns: {id: $id}, _set: $updateFields) {
      id
      status
      reject_reason
      is_team_manager_approved
      is_group_manager_approved
      is_final_approved
      approving_manager_id
      approving_manager {
        first_name
        last_name
      }
    }
  }
`;

export const UPDATE_LEAVE_REQUEST_MUTATION = `
  mutation UpdateLeaveRequest($id: Int!, $_set: leave_requests_set_input!) {
    update_leave_requests_by_pk(pk_columns: {id: $id}, _set: $_set) {
      id
      start_date
      end_date
      leave_type
      duration
      company_id
      user_id
      team_id
      group_id
      status
      user {
        id
        first_name
        last_name
        email
      }
      leaveType {
        id
        leave_type_name
        leave_type_description
      }
      company {
        id
        name
      }
    }
  }
`;

export const DELETE_LEAVE_REQUEST_MUTATION = `
  mutation DeleteLeaveRequest($id: Int!) {
    delete_leave_requests_by_pk(id: $id) {
      id
      start_date
      end_date
    }
  }
`;
